import { render } from "./ConfirmResetPassword.vue?vue&type=template&id=0d0be0df"
import script from "./ConfirmResetPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmResetPassword.vue?vue&type=script&lang=js"

import "./ConfirmResetPassword.vue?vue&type=style&index=0&id=0d0be0df&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__